import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

// style
import { Container, Content, TitleContainer } from './Guidelines.style'

// components
import CancelationPolicy from './components/CancellationPolicy.component'
import AGB from './components/AGB.component'
import DataProtection from './components/DataProtection.component'
import Impressum from './components/Impressum.component'
import { useHistory, useLocation } from 'react-router-dom'
import { guidelinesRoute } from './route'
import Withdrawal from './components/Withdrawal.component'
import { BaseSelect } from 'parkdepot-shared/components/Select'

interface Tab {
    index: number
    title: string
    content: JSX.Element
    id: string
}

export const guidelinesTabs: Tab[] = [
    {
        index: 0,
        title: 'guidelines.agb.title',
        content: <AGB />,
        id: 'gtc'
    },
    {
        index: 1,
        title: 'guidelines.withdrawal.title',
        content: <Withdrawal />,
        id: 'withdrawal'
    },
    {
        index: 2,
        title: 'guidelines.cancellationPolicy.title',
        content: <CancelationPolicy />,
        id: 'cancellation-policy'
    },
    {
        index: 3,
        title: 'guidelines.privacyPolicy.title',
        content: <DataProtection />,
        id: 'privacy-policy'
    },
    {
        index: 4,
        title: 'footer.impressum',
        content: <Impressum />,
        id: 'impressum'
    }
]

const Guidelines: FC = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const location = useLocation()

    const [selected, setSelected] = useState<Tab | null>(guidelinesTabs[0])
    const tabs = guidelinesTabs
    const [selectedTabId, setSelectedTabId] = useState<string>(guidelinesTabs[0].id)
    const getOptions = (): {
        label: string
        id: string
    }[] => {
        return guidelinesTabs.map((tab) => ({ label: t(tab.title), id: tab.id }))
    }

    useEffect(() => {
        const tab = guidelinesTabs.find((tab) => tab.id === location.pathname.split('/')[2])
        if (tab) {
            setSelected(tab)
            setSelectedTabId(tab.id)
        }
    }, [location.pathname])

    return (
        <Container className="container">
            <TitleContainer>{t('guidelines.title')}</TitleContainer>
            <BaseSelect
                options={getOptions()}
                value={tabs.map((tab) => ({ id: tab.id, label: tab.title })).filter((tab) => tab.id === selectedTabId)}
                onChange={(newValue) => {
                    const tabId = newValue.value[0]?.id ?? tabs[tabs.length - 1].id
                    history.push(`${guidelinesRoute()}/${tabId}`)
                }}
                clearable={false}
            />
            <div>{selected && <Content>{selected.content}</Content>}</div>
        </Container>
    )
}

export default Guidelines
